import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

/* eslint-disable no-param-reassign, max-len */
import qs from 'query-string';
import { logger as Logger, validateAxiosResponse as ValidateAxiosResponse } from '@dmi-mch/utils';
import Onlineshow from './onlineshow';
/**
 * This class contains the services for Events. The constructor requires a context to be passed.
 * When using the Event Class, it will require a context to be passed. The context contains the
 * http object, which is specific for each environment
 */

var Event = /*#__PURE__*/function () {
  function Event(context) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Event);

    this.context = context;
    this.headers = headers;
  }

  _createClass(Event, [{
    key: "getAttributes",
    value: function getAttributes(type, sortBy) {
      var params = {
        attributeType: type,
        limit: 2000,
        sortDirection: 'ASC',
        sortBy: sortBy
      };
      return this.context.http.get("/msvc/v1/events/attributes/?".concat(qs.stringify(params)));
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.context.http.get("/msvc/v1/events/event/".concat(id), null, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "getAll",
    value: function getAll(params) {
      return this.context.http.get('/msvc/v1/events/events', params);
    } // Updates

  }, {
    key: "putDeprecated",
    value: function putDeprecated(id, params) {
      return this.context.http.put("/msvc/v1/events/event/".concat(id), params);
    } // Updates // this should be the new PUT function.

  }, {
    key: "put",
    value: function put(id, params) {
      return this.context.http.put("/msvc/v1/events/item/".concat(id, "/properties"), params);
    }
  }, {
    key: "putCategories",
    value: function putCategories(id, params) {
      return this.context.http.put("/msvc/v1/events/item/".concat(id, "/categories"), params);
    } // Change status

  }, {
    key: "updateStatus",
    value: function updateStatus(id, status) {
      return this.context.http.put("/msvc/v1/events/event/".concat(id, "/status"), status);
    } // Creates an event (old method, to be removed when it's considered safe)

  }, {
    key: "postDeprecated",
    value: function postDeprecated(params) {
      return this.context.http.post('/msvc/v1/events/event', params);
    } // Creates an event

  }, {
    key: "post",
    value: function post(params) {
      return this.context.http.post('/msvc/v1/events/item', params);
    }
  }, {
    key: "del",
    value: function del(id) {
      return this.context.http.del("/msvc/v1/events/event/".concat(id));
    }
  }, {
    key: "getCRMActiveEvents",
    value: function getCRMActiveEvents() {
      return this.context.http.get('/msvc/v1/shows/crmActiveEvents');
    } // Get events and merge the show data if its an online room

  }, {
    key: "getEventsAndRooms",
    value: function getEventsAndRooms(params) {
      var _this = this;

      var onlineShowService = new Onlineshow(this.context);

      var mergeAll = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promises, items) {
          var events, shows;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  events = _toConsumableArray(items);
                  shows = [];
                  _context.prev = 2;
                  _context.next = 5;
                  return _Promise.all(promises).then(function (showRequest) {
                    showRequest.forEach(function (res) {
                      if (res.ok && res.data) {
                        shows.push(res.data);
                      }
                    });
                  });

                case 5:
                  events.forEach(function (event) {
                    if (event.onlineShowId) {
                      event.onlineShowData = shows.length > 0 ? shows.find(function (i) {
                        return i.id === event.onlineShowId;
                      }) : null;
                    }
                  });
                  return _context.abrupt("return", events);

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](2);
                  Logger(_context.t0);

                case 12:
                  return _context.abrupt("return", []);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 9]]);
        }));

        return function mergeAll(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();

      var fetchShowByRoomId = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(onlineShowId) {
          var req;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  req = null;
                  _context2.prev = 1;
                  _context2.next = 4;
                  return onlineShowService.getOnlineShowViews(onlineShowId);

                case 4:
                  req = _context2.sent;

                  if (!ValidateAxiosResponse(req)) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt("return", req);

                case 7:
                  _context2.next = 12;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2["catch"](1);
                  Logger(_context2.t0);

                case 12:
                  return _context2.abrupt("return", req);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 9]]);
        }));

        return function fetchShowByRoomId(_x3) {
          return _ref2.apply(this, arguments);
        };
      }();

      var fetchShow = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
          var events, promises, showsObj;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  events = _toConsumableArray(data);
                  promises = [];
                  showsObj = []; // for each event, check if its a room, and then request the show
                  // after returning the show response, store it in an array
                  // then the next time we call the show,
                  // we confirm first if the show response is not already in the array

                  events.forEach(function (event) {
                    if (event.onlineShowId) {
                      // this code avoids duplicated api calls, by storing previous responses
                      var findShowInObj = showsObj.find(function (o) {
                        return o.onlineShowId === event.onlineShowId;
                      });

                      if (typeof findShowInObj === 'object') {
                        // use an existing response
                        promises.push(findShowInObj);
                      } else {
                        var req = fetchShowByRoomId(event.onlineShowId); // push a new response

                        showsObj.push({
                          onlineShowId: event.onlineShowId,
                          data: req
                        });
                        promises.push(req);
                      }
                    }
                  });
                  return _context3.abrupt("return", mergeAll(promises, events));

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function fetchShow(_x4) {
          return _ref3.apply(this, arguments);
        };
      }();

      var fetchEvents = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var req, clonedEvents;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  req = null;
                  _context4.prev = 1;
                  _context4.next = 4;
                  return _this.getAll(params);

                case 4:
                  req = _context4.sent;

                  if (!ValidateAxiosResponse(req)) {
                    _context4.next = 11;
                    break;
                  }

                  clonedEvents = _objectSpread({}, req.data);
                  _context4.next = 9;
                  return fetchShow(req.data.items);

                case 9:
                  clonedEvents.items = _context4.sent;
                  return _context4.abrupt("return", clonedEvents);

                case 11:
                  _context4.next = 16;
                  break;

                case 13:
                  _context4.prev = 13;
                  _context4.t0 = _context4["catch"](1);
                  Logger(_context4.t0);

                case 16:
                  return _context4.abrupt("return", req);

                case 17:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[1, 13]]);
        }));

        return function fetchEvents() {
          return _ref4.apply(this, arguments);
        };
      }();

      return fetchEvents();
    }
  }]);

  return Event;
}();

export default Event;